import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFilePdf, FaRegImage } from "react-icons/fa";
import {
  handleImageChange,
  handleImgPdfChange,
  ValidateImageAndPdf,
  ValidateImageOnly,
  ValidateImgPdf,
} from "../../../utils/Utils";
import Required from "./Required";
import ViewImgAndPdf from "../modals/ViewImgAndPdf";
import { Button, Col, Icon } from "../../../components/Component";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const ImageUpload = ({
  watch,
  register,
  profile,
  errors,
  trigger,
  setValue,
  setError,
  clearErrors,
  handleImageOpenPreview,
  label,
  image,
  image_url,
  design,
  required,
  validateDoc,
  index,
  remove,
  rm,
  approve,
  isLoading,
  getValues,
  size,
  disabled=false,
}) => {
  const error = get(errors, image);
  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileTypePreview, setFileTypePreview] = useState("");
  // Get current values
  const objectionKeys = getValues("objectionKeys") || [];
  const handleRemoveImage = (errorInput, url) => {
    setValue(errorInput, "");
    setValue(url, null);
    setValue(`${image}_type`, ""); // Clear MIME type too
    const fileInput = document.getElementById(errorInput);
    if (fileInput) {
      fileInput.value = null;
    }
  };
  const handleFileValidationOld = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validateFn = validateDoc ? ValidateImageAndPdf : ValidateImageOnly;

    validateFn(file, (isValid) => {
      if (!isValid) {
        setError(image, {
          type: "manual",
          message: validateDoc ? "Only PNG, JPEG or PDF files are allowed" : "Only PNG or JPEG image files are allowed",
        });
        e.target.value = null;
        setValue(image, "");
      } else {
        clearErrors(image);
        setValue(`${image}_type`, file.type); // MIME type
        handleImgPdfChange(e, image, image_url, setValue, setError, trigger, clearErrors);
      }
    });
  };
  const handleFileValidation = (e, maxFileSizeMB = 2048) => {
  const file = e.target.files[0];
  if (!file) return;

  // Convert MB to bytes
  const maxFileSize = maxFileSizeMB *   1024;

  // First check file size
  if (file.size > maxFileSize) {
    setError(image, {
      type: "manual",
      message: `File size must be less than ${maxFileSizeMB} KB`,
    });
    e.target.value = null;
    setValue(image, "");
    return;
  }

  // Then check file type
  const validateFn = validateDoc ? ValidateImageAndPdf : ValidateImageOnly;

  validateFn(file, (isValid) => {
    if (!isValid) {
      setError(image, {
        type: "manual",
        message: validateDoc
          ? "Only PNG, JPEG or PDF files are allowed"
          : "Only PNG or JPEG image files are allowed",
      });
      e.target.value = null;
      setValue(image, "");
    } else {
      clearErrors(image);
      setValue(`${image}_type`, file.type); // MIME type
      handleImgPdfChange(
        e,
        image,
        image_url,
        setValue,
        setError,
        trigger,
        clearErrors
      );
    }
  });
};


  // const handleFileValidation = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (validateDoc) {
  //     ValidateImgPdf(file, (isValid) => {
  //       if (!isValid) {
  //         setError(image, {
  //           type: "manual",
  //           message: "Only PNG, JPEG or PDF files are allowed",
  //         });
  //         e.target.value = null;
  //         setValue(image, "");
  //       } else {
  //         clearErrors(image);
  //         setValue(`${image}_type`, file.type); // Store MIME type
  //         handleImageChange(e, image, image_url, setValue, setError, trigger, clearErrors);
  //       }
  //     });
  //   } else {
  //     setValue(`${image}_type`, file.type); // Store MIME type
  //     handleImageChange(e, image, image_url, setValue, setError, trigger, clearErrors);
  //   }
  // };
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen((prev) => !prev);
  };
  const handleImageClick = (index, image, inputName, fileType) => {
    setCurrentImageIndex(index);
    // Replace label with "Document 1" for keys like document_0_img
    const displayTitle = /^document_\d+_img$/.test(inputName)
      ? `Document ${parseInt(inputName.match(/\d+/)?.[0] || "0", 10) + 1}`
      : inputName;

    setTitleName(displayTitle);
    setFileTypePreview(fileType);

    if (fileType === "application/pdf") {
      console.log("pdf file render");

      if (image instanceof File || image instanceof Blob) {
        setModalImages([URL.createObjectURL(image)]);
      } else {
        console.log("url", image);
        // if it's a string or already a URL
        setModalImages([image]);
      }
    } else {
      setModalImages([image]);
    }

    toggleModal();
  };
 
  const guessMimeTypeFromUrl = (url) => {
    if (!url) return "";
    const extension = url.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
      case "xls":
        return "application/vnd.ms-excel";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (watch(image_url) && !watch(`${image}_type`)) {
      const guessedType = guessMimeTypeFromUrl(watch(image_url));
      setValue(`${image}_type`, guessedType);
    }
  }, [watch(image_url)]);
  
  const fileType = watch(`${image}_type`);
  const isPdfFile = fileType === "application/pdf";
  const isExcelFile = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ].includes(fileType);

  return (
    <>
      <div className="form-group ">
        {/* {watch(image_url) == null ? ( */}
        {/* <label className="form-label" htmlFor={image}> */}
        <MyLabel name={image} title={label} required={required} />
        {/* {label} {required && label && <Required />} */}
        {rm && (
          <>
            {approve || index === 0 ? null : (
              <Button type="button" color="danger" size="xs" outline onClick={() => remove(index)}>
                <Icon name="trash" />
              </Button>
            )}
          </>
        )}
        {/* </label> */}
        {/* ) : null} */}
        {(watch(image_url) === null || error) && (
          <input
          disabled={disabled}
            type="file"
            accept="image/*,application/pdf"
            className={`form-control w-100 ${error ? "is-invalid" : ""}`}
            id={image}
            {...register(image, {
              required: required
                ? {
                    value: true,
                    message: label ? `${label} is required` : "Image is required",
                  }
                : false,
            })}
            onChange={(e)=>handleFileValidation(e,size)}
            placeholder={"Upload"}
          />
        )}
        {error && <span className="invalid">{error?.message}</span>}

         <div className="col-md-3">
        {watch(image_url) && !profile && (
          <>
            {approve ? null : (
              <Button
                className={""}
                size={"xs"}
                type="button"
                onClick={() => handleRemoveImage(image, image_url)}
                style={{ cursor: "pointer" }}
              >
                <Icon color="danger" name="trash" style={{ color: "crimson" }} />
              </Button>
            )}
            {/* <span className="mx-2" onClick={() => handleRemoveImage(image, image_url)} style={{ cursor: "pointer" }}>
              x
            </span> */}

            {isPdfFile ? (
              <Button
                outline
                id="img"
                color="danger"
                type="button"
                onClick={() => handleImageClick(0, watch(image_url), label || image, fileType)}
                size="sm"
                data-toggle="tooltip"
                data-placement="top"
                title="View PDF"
                style={{
                  border: objectionKeys.includes(image) && "2px solid crimson",
                }}
              >
                <Icon name="file-pdf" />
              </Button>
            ) : isExcelFile ? (
              <Button
                outline
                color="success"
                type="button"
                size="sm"
                title="Download Excel"
                onClick={() => handleImageClick(0, watch(image_url), label || image, fileType)}
                style={{
                  border: objectionKeys.includes(image) && "2px solid crimson",
                }}
              >
                <Icon name="file-xls" /> {/* Excel icon */}
              </Button>
            ) : (
              <img
                src={watch(image_url)}
                alt={image}
                style={{
                  maxWidth: "60px",
                  maxHeight: "60px",
                  marginLeft: "20px",
                  objectFit: "cover",
                  padding:"4px",
                  border:"1px solid #ddd",
                  cursor: "pointer",
                  border: objectionKeys.includes(image) && "2px solid crimson",
                }}
                className={objectionKeys.includes(image) && "is-invalid"}
                onClick={() => handleImageClick(0, watch(image_url), label || image, fileType)}
              />
            )}
          </>
        )}
      </div>
      </div>

     

      <ViewImgAndPdf
        fileType={fileTypePreview}
        titleName={titleName}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        images={modalImages}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
        docUploadView={true}
        setValue={setValue}
        approve={approve}
        isLoading={isLoading}
        image={image}
        getValues={getValues}
        trigger={trigger}
        watch={watch}
        image_url={image_url}
      />
    </>
  );
};

export default ImageUpload;
